// URL
import { CARD_LIMIT } from '../Data';
export const URL_GET_TRANSACTION = `/transactions?_limit=${CARD_LIMIT}%(params)s`;

// Types
export const types = {
    GET_TRANSACTION_LOADING: 'GET_TRANSACTION_LOADING',
    GET_TRANSACTION_SUCCESS: 'GET_TRANSACTION_SUCCESS',
    GET_TRANSACTION_FAILED: 'GET_TRANSACTION_FAILED',
};
